import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Grid, Row, Col } from 'react-bootstrap/lib';

class Footer extends Component {
    render() {
        return (
            <footer>
                <Grid fluid>
                    <Row className="footer">
                        <Col className="text-center" md={12}>
                            <h1>NATUS<span>.IO</span></h1>
                            <ul className="social-links">
                                <li><a href="https://www.linkedin.com/in/ignatus" className="fa fa-linkedin">LinkedIn</a></li>
                                <li><a href="https://github.com/coingod" className="fa fa-github">GitHub</a></li>
                                <li><a href="https://ar.pinterest.com/ignatuus/" className="fa fa-pinterest">Pinterest</a></li>
                                <li><a href="mailto:ignacioa.del.barrio@gmail.com?Subject=Hello%20World!" target="_top" className="fa fa-at">Email</a></li>
                            </ul>
                        </Col>
                    </Row>
                    <Row className="sub-footer">
                        <Col className="text-center" md={12}>
                            <p>Copyright © 2018 <a href="#">natus.io</a> | Ignacio del Barrio</p>
                        </Col>
                    </Row>
                </Grid>
            </footer>
        );
    }
}

export default connect()(Footer);


// WEBPACK FOOTER //
// ./src/components/Footer.js